<template>
  <div class="address-edit">
    <div class="address-edit__item">
      <div class="address-edit__item-label">{{ $t('addressPop.name') }}</div>
      <div class="address-edit__item-value">
        <input class="address-edit__input" maxlength="50" type="text" v-model="address.recipientName" />
      </div>
    </div>

    <div class="address-edit__item">
      <div class="address-edit__item-label">{{ $t('addressPop.phone') }}</div>
      <div class="address-edit__item-value">
        <input class="address-edit__input" type="tel" maxlength="13" v-model="address.recipientPhone"
          @input="handlePhoneInput" />
      </div>
    </div>
    <div class="address-edit__item" :class="{ active: hasRegion }" @click="openAreaSelection">
      <div class="address-edit__item-label">{{ $t('addressPop.region') }}</div>
      <div class="address-edit__area">{{ regions }}</div>
    </div>
    <div class="address-edit__item">
      <div class="address-edit__item-label">{{ $t('addressPop.detail') }}</div>
      <div class="address-edit__item-value">
        <textarea class="address-edit__input textarea" type="tel" maxlength="300"
          v-model="address.detailedAddress"></textarea>
      </div>
    </div>
    <Checkbox v-model="address.isDefault" class="address-edit__checkbox">{{ $t('default') }}</Checkbox>
    <div class="address-edit__footer">
      <div class="btn-primary" @click="confirmAdd">{{ $t('confirm') }}</div>
    </div>
    <AreaSelection
      v-if="isLoad"
      ref="areaSelection"
      :defaultValue="areaCode"
      :defaultProvinceCode="address.provinceCode"
      :defaultCityCode="address.cityCode"
      :defaultRegionCode="address.regionCode"
      @confirm="onAreaConfirm"
    >
    </AreaSelection>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { Checkbox } from 'vant';
import AreaSelection from './AreaSelection.vue';
export default {
  name: 'AddressEdit',
  components: {
    Checkbox,
    AreaSelection
  },
  props: {
    editAddress: {
      type: Object,
      default: null
    }
  },
  computed: {
    isAdd() {
      return !this.editAddress;
    },
    hasRegion() {
      return !!this.address.province;
    },
    regions() {
      if (this.address.province) {
        const parts = [];
        if (this.address.region) parts.push(this.address.region);
        if (this.address.city) parts.push(this.address.city);
        if (this.address.province) parts.push(this.address.province);
        return parts.join(', ');
      } else {
        return this.$t('addressPop.regionsPlaceholder');
      }
    },
  },

  data() {
    return {
      isLoad: false,
      areaCode: '',
      addressId: '',
      address: {
        recipientName: '',
        recipientPhone: '',
        provinceCode: '',
        provinceEn: '',
        provinceId: '',
        provincePh: '',
        province: '',
        cityCode: '',
        cityEn: '',
        cityId: '',
        cityPh: '',
        city: '',
        regionCode: '',
        regionEn: '',
        regionId: '',
        regionPh: '',
        region: '',
        detailedAddress: '',
        isDefault: false,
      },
    }
  },
  created() {
    if (this.editAddress) {
      let address = {
        ...this.editAddress
      };
      this.addressId = address.id;
      delete address.id

      // 兼容旧数据
      if (address.city && !address.province) {
        address.province = address.city;
        address.provinceCode = address.cityCode;
        address.provinceEn = address.cityEn;
        address.provincePh = address.cityPh;
        address.city = '';
        address.cityCode = '';
      }

      // 处理手机号回显，去掉62前缀
      if (address.recipientPhone && address.recipientPhone.startsWith('62')) {
        address.recipientPhone = address.recipientPhone.substring(2);
      }

      this.address = address;
      this.areaCode = this.normalizeAreaCode(address.regionCode || address.cityCode || address.provinceCode || '');
    }
    this.isLoad = true;
  },
  methods: {
    ...mapActions('user', ['saveAddress']),
    normalizeAreaCode(value) {
      const code = parseInt(value, 10);
      return Number.isNaN(code) ? '' : code;
    },
    handlePhoneInput(event) {
      // 只允许输入数字，并限制长度为10位
      let value = event.target.value.replace(/[^\d]/g, '');
      // if (value.length > 10) {
      //   value = value.slice(0, 10);
      // }
      this.address.recipientPhone = value;
    },
    checkInput() {
      if (!this.address.recipientName) {
        this.$toast(this.$t('addressPop.nameEmpty'));
        return false;
      }
      if (!this.address.recipientPhone) {
        this.$toast(this.$t('addressPop.phoneEmpty'));
        return false;
      }
      if (!this.$utils.validatePhone(this.address.recipientPhone)) {
        this.$toast(this.$t('addressPop.phoneError'));
        return false;
      }
      if (!this.areaCode) {
        this.$toast(this.$t('addressPop.regionEmpty'));
        return false;
      }
      if (!this.address.detailedAddress) {
        this.$toast(this.$t('addressPop.detailEmpty'));
        return false;
      }
      return true;
    },
    async confirmAdd() {
      if (!this.checkInput()) {
        return;
      }
      let address = {
        ...this.address,
      }
      if (this.addressId) {
        address.id = this.addressId;
      }

      let mobile = address.recipientPhone
      if (mobile.startsWith('0')) {
        mobile = '62' + mobile.substring(1);
      } else if (!mobile.startsWith('62')) {
        mobile = '62' + mobile;
      }
      address.recipientPhone = mobile

      let res = await this.saveAddress(address)
      if (res) {
        this.$emit('success', {
          data: {
            ...this.address,
            id: res.data?.id || this.addressId || ''
          }
        })
      }
    },
    onAreaConfirm(data) {
      let province = data.selectedArea[0] || {};
      let city = data.selectedArea[1] || {};
      let region = data.selectedArea[2] || {};

      this.address.provinceCode = province.code + '';
      this.address.provinceEn = province.name_en || '';
      this.address.provinceId = province.name_id || '';
      this.address.provincePh = province.name_ph || '';
      this.address.province = province.name || '';

      this.address.cityCode = city.code + '';
      this.address.cityEn = city.name_en || '';
      this.address.cityId = city.name_id || '';
      this.address.cityPh = city.name_ph || '';
      this.address.city = city.name || '';

      this.address.regionCode = region.code + '';
      this.address.regionEn = region.name_en || '';
      this.address.regionId = region.name_id || '';
      this.address.regionPh = region.name_ph || '';
      this.address.region = region.name || '';

      this.areaCode = this.normalizeAreaCode(region.code || city.code || province.code || '');
    },
    openAreaSelection() {
      this.$refs.areaSelection.open();
    },
    clear() {
      this.addressId = '';
      this.address = {};
    }
  }
}
</script>

<style lang="less" scoped>
.address-edit {
  padding: 18px 0 0;

  &__item {
    margin-top: 24px;

    &:first-child {
      margin-top: 0;
    }

    &-label {
      font-weight: 500;
      font-size: 32px;
      line-height: 32px;
    }
  }

  &__input {
    margin-top: 12px;
    width: 100%;
    border: 1px solid var(--border-color-base);
    border-radius: var(--border-radius-base);
    padding: 14px 20px;
    box-sizing: border-box;
    font-size: 32px;
    line-height: 60px;

    &.textarea {
      height: 180px;
      padding: 20px;
      font-size: 32px;
      line-height: 37px;
      resize: none;
    }
  }

  &__area {
    margin-top: 12px;
    background: #FFFFFF;
    border-radius: var(--border-radius-base);
    border: 1px solid #D8D8D8;
    padding: 20px;
    font-weight: 500;
    font-size: 32px;
    color: var(--text-color-gray);
    line-height: 44px;
    text-align: left;
  }

  &__checkbox {
    margin-top: 12px;
    justify-content: end;

    /deep/ .van-checkbox__label {
      font-size: 26px;
      color: var(--text-color-gray);
      line-height: 38px;
    }
  }

  &__footer {
    margin-top: 24px;

    .btn-primary {
      border-radius: 14px;
    }
  }
}

.active {
  .address-edit__area {
    color: var(--text-color-black);
  }
}
</style>
